// Angular
import { Params } from '@angular/router';

// Models
import { BopInspectionObject } from '../../modules/job/components/bop-inspection/bop-inspection.component';
import { JobCommentDefaultGroupLocalStorage } from '../../modules/comment/models/job-comment-default-group-dto';
import { DrawerModel, ToasterModel } from '../models';
import { SideNavModel } from './storage.state';
import { UserDashboardSettings } from '../../modules/channel/models/user-dashboard-settings.model';

export namespace StorageActions {
	export class SetTenantId {
		static readonly type = '[Storage] Set Tenant Id';
		constructor(public tenantId: number) {}
	}
	
	export class SetCommentGroups {
		static readonly type = '[Storage] Set Comment Groups';
		constructor(public defaultCommentGroups: JobCommentDefaultGroupLocalStorage[]) {}
	}
	
	export class SetCommentFontSize {
		static readonly type = '[Storage] Set Comment Font Size';
		constructor(public fontSize: string) {}
	}
	
	export class SetCommentDrawerSettings {
		static readonly type = '[Storage] Set Comment Drawer';
		constructor(public commentDrawerSettings: DrawerModel) {}
	}
	
	export class SetModelDrawerSettings {
		static readonly type = '[Storage] Set Model Drawer';
		constructor(public modelDrawerSettings: DrawerModel) {}
	}
	
	export class SetSelectedFilterJobTypeIds {
		static readonly type = '[Storage] Set Selected Filter Job Type Ids';
		constructor(public jobTypeIds: number[]) {}
	}
	
	export class SetToastHistory {
		static readonly type = '[Storage] Set Toast History';
		constructor(public toastHistory: ToasterModel[]) {}
	}
	
	export class ClearToastHistory {
		static readonly type = '[Storage] Clear Toast History';
	}
	
	export class SetSideNav {
		static readonly type = '[Storage] Set Side Nav';
		constructor(public sideNav: SideNavModel) {}
	}
	
	export class SetLanguage {
		static readonly type = '[Storage] Set Translation';
		constructor(public language: string) {}
	}
	
	export class SetDashboardId {
		static readonly type = '[Storage] Set Dashboard Id';
		constructor(public language: string) {}
	}
	
	export class SetCurrentRoute {
		static readonly type = '[Storage] Set Current Route';
		constructor(public currentRoute: string) {}
	}
	
	export class SetJobRouteParams {
		static readonly type = '[Storage] Set Job Route Params';
		constructor(public params: Params) {}
	}
	
	export class SetCurrentDashboardId {
		static readonly type = '[Storage] Set Current Dashboard Id';
		constructor(public id: number) {}
	}
	
	export class SetUserDashboardSettings {
		static readonly type = '[Storage] Set User Dashboard Settings';
		constructor(public settings: UserDashboardSettings) {}
	}
	
	export class AddBopReport {
		static readonly type = '[Storage] Add Bop Report';
		constructor(public bopReportObject: BopInspectionObject) {}
	}
	
	export class SetDarkMode {
		static readonly type = '[Storage] Set Dark Mode';
		constructor(public darkMode: boolean) {}
	}
	
	export class SetAppBrightness {
		static readonly type = '[Storage] Set App Brightness';
		constructor(public brightness: string) {}
	}
	
	export class SetDeviceTypes {
		static readonly type = '[Storage] Set Device Types';
		constructor(public types: any) {}
	}
}